import {
  Component,
  OnInit,
  EventEmitter,
  HostBinding,
  Output,
  HostListener,
} from "@angular/core";
import { FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
//import { FileHandle } from './dragDrop.directive';
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-repositoryform",
  templateUrl: "./repositoryform.component.html",
  styleUrls: ["./repositoryform.component.scss"],
})
export class RepositoryformComponent implements OnInit {
  // @Output() files: EventEmitter<FileHandle[]> = new EventEmitter();

  // @HostBinding("style.background") private background = "#eee";

  // files: FileHandle[] = [];

  public validator = {
    errorMessage: "",
    UniqueRepository: false,
    isfolderName: false,
  };

  Repository = new FormGroup({
    userId: new FormControl(),
    folderName: new FormControl(),
    FileName: new FormControl(),
  });

  logo: File;
  logoPreview: string | ArrayBuffer;
  sanitizer: any;
  userid: any;
  created_By: any;
  background: string;
  repository: any;
  file: File;
  files: any[];
  urls = [];
  Rloader = false;

  constructor(
    private router: Router,
    private daoService: DaoService,
    private fb: FormBuilder,
    private token: LstorageService,
    public dialogRef: MatDialogRef<RepositoryformComponent>
  ) {}

  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#999";
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#eee";
  }

  @HostListener("drop", ["$event"]) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = "#eee";
  }

  ngOnInit() {
    this.Repository = this.fb.group({
      userId: [""],
      folderName: [""],
      FileName: [""],
    });
  }

  onfileselected(event) {
    this.file = event.target.files[0] as File;
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        this.logoPreview = this.file.name;
      };
    }
  }

  onSelectFile(event) {
    this.logoPreview = "";
    this.files = event.target.files;
    if (event.target.files && event.target.files[0]) {
      var filesAmount = event.target.files.length;
      for (let i = 0; i < this.files.length; i++) {
        var reader = new FileReader();
        this.logoPreview += " " + this.files[i].name;
        reader.onload = (event: any) => {
          //console.log(event.target.result);
          // this.urls.push(event.target.result);
        };

        //reader.readAsDataURL(event.target.files[i]);
      }
    }
  }

  createtemplate() {
    this.validator.UniqueRepository = false;
    let user = jwtDecode(this.token.getToken());
    this.Repository.value.userId = user.unique_name;
    this.validator.isfolderName = false;
    if (this.Repository.value.folderName) {
      this.Rloader = true;
      this.daoService.AddRepository(this.Repository.value).subscribe(
        (data: any) => {
          if (data.isSuccess) {
            if (this.files) {
              const fd = new FormData();
              for (var i = 0; i < this.files.length; i++) {
                fd.append("file", this.files[i] as File);
              }

              this.daoService.Uploadfile(this.Repository.value, fd).subscribe(
                (data: any) => {
                  this.Rloader = false;
                  this.dialogRef.close();
                  location.reload();
                },
                (error) => {
                  this.Rloader = false;
                  this.validator.UniqueRepository = true;
                  this.validator.errorMessage = error.error.userMessage;
                }
              );
            } else {
              this.dialogRef.close();
            }
          }
        },
        (err) => {
          console.log(err), (this.Rloader = false);
        }
      );
    } else {
      this.validator.isfolderName = true;
    }
  }

  handleInput(event) {
    if (event.which === 32 && !this.Repository.value.folderName.length)
      event.preventDefault();
  }

  // filesDropped(files: FileHandle[]): void {
  //   this.files = files;
  // }
  //   onFileComplete(data: any) {
  //     console.log(data);
  //   }
  closeRepositoryForm() {
    this.dialogRef.close();
  }
}
